import React from 'react';
import { I } from '../../common/v5/config';

const isNumericId = (id) => typeof id === 'number' || (typeof id === 'string' && id !== '' && !Number.isNaN(Number(id)));

const V5Select = ({
  label,
  value,
  options = [],
  onChange,
  required = false,
  placeholder = '',
  disabled = false,
  name,
  id
}) => {
  const optionsAreNumeric = options.length > 0 && options.every((o) => isNumericId(o.id));

  const handleChange = (e) => {
    const raw = e.target.value;
    if (!onChange) return;
    if (optionsAreNumeric) {
      const n = parseInt(raw, 10);
      onChange(Number.isNaN(n) ? 0 : n, name);
    } else {
      onChange(raw, name);
    }
  };

  // Preserve 0 / falsey numeric values — never coerce 0 to ''
  const selectValue = value === undefined || value === null ? '' : String(value);

  return (
    <div className="v5-form-group">
      {label && (
        <label className="v5-form-label" htmlFor={id}>
          {typeof label === 'string' ? I(label) : label}
          {required && <span className="required-asterisk">*</span>}
        </label>
      )}
      <select
        id={id}
        name={name}
        value={selectValue}
        onChange={handleChange}
        disabled={disabled}
        className="v5-form-select"
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.length > 0 ? (
          options.map((opt) => (
            <option key={String(opt.id)} value={String(opt.id)}>
              {opt.name}
            </option>
          ))
        ) : (
          <option value="" disabled>{I('No options available')}</option>
        )}
      </select>
    </div>
  );
};

export default V5Select;
